import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {FilterAbstractModel} from "../../../../models/FilterAbstractModel";

@Component({
  selector: 'app-delta-filter',
  templateUrl: './delta-filter.component.html',
  styleUrls: ['./delta-filter.component.scss']
})
export class DeltaFilterComponent extends FilterAbstractModel implements OnInit, OnChanges {

  optionSelected: number;

  @Input() deltaFilterSelected: number;

  constructor() {
    super();
  }

  ngOnInit() {}

  ngOnChanges() {
    if (this.deltaFilterSelected) {
      this.optionSelected = this.deltaFilterSelected;
    }
  }

  reset() {
    this.optionSelected = null;
  }

}
